import type React from "react";

import { DirectionsIcon } from "../app/components/icons";

const DirectionsShortcutButton: React.FC<{
  onClick: () => void;
  shown: boolean;
}> = ({ onClick, shown = true }) => {
  if (!shown) return <></>;

  return (
    <button
      onClick={onClick}
      className={"map-toolbar__button navigation__button"}
    >
      <DirectionsIcon className="map-toolbar__button__icon" />
    </button>
  );
};

export default DirectionsShortcutButton;
